import { tassign } from 'tassign';

import { CustomerAction, CustomerActions } from './customer.actions';

export interface CustomerState {
    profile: any;
    actions: string[];
    customerFields: string[];
    loaded: boolean;
    error: any;
    isFormSubmitted: boolean;
    isDeletionEmailSuccess: false;
    isDeletionSuccess: boolean;
    isEmailChangeSent: boolean;
    isEmailChanged: boolean;
}

export const CUSTOMER_INITIAL_STATE: CustomerState = {
    profile: {},
    actions: [],
    customerFields: [],
    loaded: false,
    error: null,
    isFormSubmitted: false,
    isDeletionEmailSuccess: false,
    isDeletionSuccess: false,
    isEmailChangeSent: false,
    isEmailChanged: false
};

export const CUSTOMER_STATE_KEY = 'customer';

export function customerReducer(
    lastState: CustomerState = CUSTOMER_INITIAL_STATE,
    action: CustomerAction
): CustomerState {
    switch (action.type) {
        case CustomerActions.SET_CUSTOMER_PROFILE:
            return tassign(lastState, {
                profile: action.payload,
                loaded: true
            });
        case CustomerActions.CLEAR_CUSTOMER_PROFILE:
            return tassign(lastState, CUSTOMER_INITIAL_STATE);
        case CustomerActions.SET_CUSTOMER_PROFILE_ACTIONS:
            return tassign(lastState, {
                actions: action.payload
            });
        case CustomerActions.SET_CUSTOMER_PROFILE_FIELDS:
            return tassign(lastState, {
                customerFields: action.payload,
                isFormSubmitted: false
            });
        case CustomerActions.SAVE_CUSTOMER_PROFILE:
            return tassign(lastState, {
                profile: { ...lastState.profile, ...action.payload },
                isFormSubmitted: false
            });
        case CustomerActions.SAVE_CUSTOMER_PROFILE_SUCCESS:
            return tassign(lastState, {
                profile: { ...lastState.profile, ...action.payload },
                isFormSubmitted: true,
                error: null
            });
        case CustomerActions.SAVE_CUSTOMER_PROFILE_FAILED:
            return tassign(lastState, {
                error: action.payload,
                isFormSubmitted: true
            });
        case CustomerActions.SEND_CUSTOMER_PROFILE_DELETION_EMAIL:
            return tassign(lastState);
        case CustomerActions.SEND_CUSTOMER_PROFILE_DELETION_EMAIL_SUCCESS:
            return tassign(lastState, {
                isDeletionEmailSuccess: action.payload
            });
        case CustomerActions.SEND_CUSTOMER_PROFILE_DELETION_EMAIL_FAILED:
            return tassign(lastState, {
                error: action.payload
            });
        case CustomerActions.DELETE_CUSTOMER_PROFILE:
            return tassign(lastState);
        case CustomerActions.DELETE_CUSTOMER_PROFILE_SUCCESS:
            return tassign(lastState, {
                isDeletionSuccess: action.payload,
                error: null
            });
        case CustomerActions.DELETE_CUSTOMER_PROFILE_FAILED:
            return tassign(lastState, {
                error: action.payload
            });
        case CustomerActions.RESET_CUSTOMER_NEW_EMAIL:
            return tassign(lastState, {
                isEmailChangeSent: false,
                error: null
            });
        case CustomerActions.SEND_CUSTOMER_NEW_EMAIL_SUCCESS:
            return tassign(lastState, {
                isEmailChangeSent: action.payload,
                error: null
            });
        case CustomerActions.SEND_CUSTOMER_NEW_EMAIL_FAILED:
            return tassign(lastState, {
                error: action.payload
            });
        case CustomerActions.SAVE_CUSTOMER_NEW_EMAIL_SUCCESS:
            return tassign(lastState, {
                isEmailChanged: action.payload,
                error: null
            });
        case CustomerActions.SAVE_CUSTOMER_NEW_EMAIL_FAILED:
            return tassign(lastState, {
                error: action.payload
            });
    }
    // We don't care about any other actions right now.
    return lastState;
}

export interface CustomerPartialStoreState {
    [CUSTOMER_STATE_KEY]: CustomerState;
}
